const headerContentArray = [
  {
    subpage: "None",
    title: "Propel your business.",
    subtitle:
      "Propel comes with everything you need to get your business rolling.",
    colorBackground: false,
  },

  {
    subpage: "Features",
    title: "Expect only the best meals from us.",
    subtitle:
      "At sint tollit veritus duo, ex tota inimicus dissentiunt usu. Dico tamquam perfecto usu id. Eu nec option perfecto vituperatoribus. Ea qui congue patrioque, quo ei recteque consequuntur.",
    colorBackground: true,
  },

  {
    subpage: "Premium",
    title: "Personalized and total service.",
    subtitle:
      "At sint tollit veritus duo, ex tota inimicus dissentiunt usu. Dico tamquam perfecto usu id. Eu nec option perfecto vituperatoribus. Ea qui congue patrioque, quo ei recteque consequuntur.",
    colorBackground: true,
  },

  {
    subpage: "Pricing",
    title: "A payment plan for every occasion.",
    subtitle:
      "At sint tollit veritus duo, ex tota inimicus dissentiunt usu. Dico tamquam perfecto usu id. Eu nec option perfecto vituperatoribus. Ea qui congue patrioque, quo ei recteque consequuntur.",
    colorBackground: true,
  },

  {
    subpage: "About",
    title: "Changing the catering game.",
    subtitle:
      "At sint tollit veritus duo, ex tota inimicus dissentiunt usu. Dico tamquam perfecto usu id. Eu nec option perfecto vituperatoribus. Ea qui congue patrioque, quo ei recteque consequuntur.",
    colorBackground: true,
  },
];

export default headerContentArray;
